import type { AgentBase, AgentOptions } from './agentBase';
import { ExpectiminimaxBot } from './expectiminimaxBot';
import { HardBot } from './hardBot';
import { Human } from './human';
import { LowestBot } from './lowestBot';
import { MediumBot } from './mediumBot';
import { RandomBot } from './randomBot';

export type BotAlgorithm = 'Human' | 'RandomBot' | 'LowestBot' | 'MediumBot' | 'HardBot' | 'ExpectiminimaxBot';

export const BOT_ALGORITHMS: readonly BotAlgorithm[] = ['Human', 'RandomBot', 'LowestBot', 'MediumBot', 'HardBot', 'ExpectiminimaxBot'];

export interface BotFactoryOptions extends AgentOptions {
	algorithm?: BotAlgorithm;
	autoAdvanceRound?: boolean;
	searchWorker?: Worker;
}

export function createAgent(options: BotFactoryOptions): AgentBase {
	const { algorithm, searchWorker, ...agentOptions } = options;

	switch (algorithm) {
		case 'Human':
			return new Human(agentOptions);
		case 'RandomBot':
			return new RandomBot(agentOptions);
		case 'MediumBot':
			return new MediumBot(agentOptions);
		case 'HardBot':
			return new HardBot(agentOptions);
		case 'ExpectiminimaxBot':
			return new ExpectiminimaxBot({
				...agentOptions,
				searchWorker,
			});
		case 'LowestBot':
		default:
			return new LowestBot(agentOptions);
	}
}
